import Apple from './Apple-view';

export default Apple;
